import {
  GET_PRODUCT_CATEGORY_LIST_REQUEST,
  GET_PRODUCT_CATEGORY_LIST_RESPONSE,
  ADD_PRODUCT_CATEGORY_REQUEST,
  ADD_PRODUCT_CATEGORY_RESPONSE,
  UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST,
  UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE,
  DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST,
  DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE,
  UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_REQUEST,
  UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_RESPONSE,
} from "./actionTypes";

export const getProductCategoryListRequest = () => {
  return {
    type: GET_PRODUCT_CATEGORY_LIST_REQUEST,
  };
};

export const getProductCategoryListResponse = (apiResponse) => {
  return {
    type: GET_PRODUCT_CATEGORY_LIST_RESPONSE,
    payload: { apiResponse },
  };
};

export const addProductCategoryRequest = (data) => {
  return {
    type: ADD_PRODUCT_CATEGORY_REQUEST,
    payload: { data },
  };
};

export const addProductCategoryResponse = (apiResponse) => {
  return {
    type: ADD_PRODUCT_CATEGORY_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateProductCategoryByProductCategoryIdRequest = (
  productCategoryId,
  data
) => {
  return {
    type: UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST,
    payload: { productCategoryId, data },
  };
};

export const updateProductCategoryByProductCategoryIdResponse = (
  apiResponse
) => {
  return {
    type: UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateProductCategoryStatusByProductCategoryIdRequest = (
  productCategoryId,
  status
) => {
  return {
    type: UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_REQUEST,
    payload: { productCategoryId, status },
  };
};

export const updateProductCategoryStatusByProductCategoryIdResponse = (
  apiResponse
) => {
  return {
    type: UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const deleteProductCategoryByProductCategoryIdRequest = (
  productCategoryId
) => {
  return {
    type: DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST,
    payload: { productCategoryId },
  };
};

export const deleteProductCategoryByProductCategoryIdResponse = (
  apiResponse
) => {
  return {
    type: DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE,
    payload: { apiResponse },
  };
};
